import { tokenService } from "@/lib/client/tokenService";
const API_URL = process.env.NEXT_PUBLIC_API_URL || "";

export type AdminApiResponse<T> = {
  success: boolean;
  data?: T;
  error?: string;
  code?: string;
  status?: number;
};

export type AdminUpdateItemPayload = {
  title?: string;
  price?: string | number;
  priceusd?: number;
  currency?: string;
  vendorname?: string | number;
  itemavailability?: number;
  itemtype?: string; // Category type (tops, bottoms, etc.)
};

const adminApiCall = async <T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<AdminApiResponse<T>> => {
  try {
    const token = await tokenService.getToken();
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string>),
    };

    if (token) {
      (headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${API_URL}/api/v2/admin${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error:
          errorData.error?.message ||
          errorData.message ||
          `HTTP ${response.status}: ${response.statusText}`,
        code: errorData.error?.code || errorData.code,
        status: response.status,
      };
    }

    const responseData = await response.json();
    return {
      success: true,
      data: responseData.data || responseData,
    };
  } catch (error) {
    return {
      success: false,
      error: (error as Error).message,
    };
  }
};

export const adminApi = {
  updateItem: async (
    itemId: number,
    payload: AdminUpdateItemPayload
  ): Promise<AdminApiResponse<unknown>> => {
    return adminApiCall(`/items/${itemId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },

  hideItem: async (itemId: number): Promise<AdminApiResponse<unknown>> => {
    return adminApiCall(`/items/${itemId}/hide`, {
      method: "PATCH",
    });
  },
};
